import AuthenticationService from '../services/AuthenticationService'

export default {
  trim(string) {
    if (string) return string.trim()
  },
  async handleError(err, vm, instanceId) {
    console.error(err)
    if (err.response) {
      if (err.response.status === 401 && vm.$route.name !== 'login') {
        if (instanceId) {
          const loading = vm.$loading({
            lock: true,
            //text: "Working",
            background: 'rgba(0, 0, 0, 0.3)',
          })
          try {
            await AuthenticationService.logout({ instanceId })
              .then(vm.$store.dispatch('logoutPA'))
              .then(vm.$store.dispatch('resetEnvironment'))
              .then(vm.$store.dispatch('logoutRDM'))
              .then(vm.$router.push({ name: 'login' }))
          } catch (err) {
            vm.$message({
              type: 'warning',
              message: err.response ? err.response.data.error : err,
              duration: 7000,
              showClose: true,
            })
          } finally {
            loading.close()
          }
        } else {
          vm.$store.dispatch('resetEnvironment')
          vm.$store.dispatch('logoutRDM')
          vm.$router.push({ name: 'login' })
        }
      } else {
        vm.$message({
          type: 'warning',
          message: err.response.data.error,
          duration: 7000,
          showClose: true,
        })
      }
    } else {
      vm.$message({
        type: 'warning',
        message: err,
        duration: 7000,
        showClose: true,
      })
    }
  },
}
